import { AxiosUtil } from '../utils/axiosUtil';
import { HttpMethod } from '../utils/enums';
import { getMbServerToken } from '../../utils/cookieUtils';

export class ReimbersmentApiHelper {

  static apiUrl = process.env.REACT_APP_REIMBURSEMENT_URL
  
  static async uploadUsingFormData(formData) {

    const authToken = getMbServerToken();


    const headers = {
      authtoken: authToken
    }

    const response = await AxiosUtil.request(this.apiUrl, HttpMethod.POST, '/files/upload-raw', formData, headers)

    return response?.data
  }
}
